import React, { useState } from "react"

import { useTranslation } from "react-i18next"

import {Modal} from "components/modals/Modal"

import { AdminPlayerBonus2 } from "services/bonus/type"

interface AwardSpinsModalProps {
  target: AdminPlayerBonus2
  onClose: () => void
  onAward: (spinsCount: number, expirationDays: number) => void
}

export const AwardSpinsModal: React.FC<AwardSpinsModalProps> = ({ target, onClose, onAward }) => {
  const { t } = useTranslation("translation", { useSuspense: false })
  const [spinsCount, setSpinsCount] = useState(10)
  const [expirationDays, setExpirationDays] = useState(7)

  const inputClassName = "w-full input input-bordered bg-[rgba(0,0,0,0.05)] dark:bg-[rgba(0,0,0,0.2)]"
  const labelClassName = "label-text dark:text-gray-300"

  return (
    <Modal open={true} handler={onClose}>
      <div className="modal-box w-full max-w-md">
        <h3 className="text-lg font-bold dark:text-white mb-4">{t("bonus2.spins.awardAdditionalFreeSpins")}</h3>

        <div className="space-y-4">
          <div className="bg-base-200 dark:bg-[#0C0C1A] rounded-lg p-3">
            <div className="text-gray-500 dark:text-gray-400 text-sm">{t("bonus2.spins.player")}</div>
            <div className="dark:text-white font-semibold">{target.user_id}</div>
          </div>

          <div className="bg-base-200 dark:bg-[#0C0C1A] rounded-lg p-3">
            <div className="text-gray-500 dark:text-gray-400 text-sm">{t("bonus2.spins.currentSpins")}</div>
            <div className="text-emerald-500 dark:text-emerald-400 font-semibold">
              {target.free_spins_remaining} remaining / {target.free_spins_awarded} total
            </div>
          </div>

          <div className="form-control">
            <label className="label">
              <span className={labelClassName}>{t("bonus2.spins.spinsToAward")}</span>
            </label>
            <input
              type="number"
              min={1}
              value={spinsCount}
              onChange={(e) => setSpinsCount(parseInt(e.target.value) || 0)}
              className={inputClassName}
            />
          </div>

          <div className="form-control">
            <label className="label">
              <span className={labelClassName}>{t("bonus2.spins.expirationDaysForNew")}</span>
            </label>
            <input
              type="number"
              min={1}
              value={expirationDays}
              onChange={(e) => setExpirationDays(parseInt(e.target.value) || 7)}
              className={inputClassName}
            />
            <label className="label">
              <span className="label-text-alt text-gray-400">{t("bonus2.spins.ifPlayerHasNo")}</span>
            </label>
          </div>

          <div className="modal-action">
            <button type="button" onClick={onClose} className="btn btn-secondary">
              {t("bonus2.spins.cancel")}
            </button>
            <button onClick={() => onAward(spinsCount, expirationDays)} disabled={spinsCount <= 0} className="btn btn-primary">
              Award {spinsCount} Spins
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
